export const categories = [
  {
    slug: 'juese-shiying',
    name: '角色适应',
    description: '从独立女性到妻子角色，学会在婚姻中找到自己的位置与节奏',
    icon: 'ri-user-heart-line',
    color: 'primary',
    articleCount: 12,
  },
  {
    slug: 'jiating-jingying',
    name: '家庭经营',
    description: '家务分工、财务规划、家庭关系维系，打造温馨有序的家庭生活',
    icon: 'ri-home-heart-line',
    color: 'accent',
    articleCount: 10,
  },
  {
    slug: 'fuqi-goutong',
    name: '夫妻沟通',
    description: '掌握爱的语言，学会表达需求、倾听对方、化解矛盾',
    icon: 'ri-chat-heart-line',
    color: 'secondary',
    articleCount: 15,
  },
  {
    slug: 'ziwo-chengzhang',
    name: '自我成长',
    description: '婚后不迷失自我，持续学习、保持独立、活出精彩',
    icon: 'ri-plant-line',
    color: 'primary',
    articleCount: 8,
  },
  {
    slug: 'poxi-xiangchu',
    name: '婆媳相处',
    description: '理解代际差异，建立边界与尊重，营造和谐的婆媳关系',
    icon: 'ri-hand-heart-line',
    color: 'accent',
    articleCount: 9,
  },
  {
    slug: 'hunyin-zhihui',
    name: '婚姻智慧',
    description: '从热恋到相守，经营长久婚姻的智慧与心法',
    icon: 'ri-lightbulb-flash-line',
    color: 'secondary',
    articleCount: 11,
  },
];

export const articles = [
  {
    slug: 'xinhun-di-yizhou-jiating-juese',
    title: '新婚第一周：如何快速适应家庭新角色',
    excerpt: '婚礼的喧嚣散去，属于两个人的新生活才刚刚开始。面对全新的家庭角色，许多新婚妻子会感到迷茫和不安——从"女友"到"妻子"，这个身份转变远比想象中复杂。本文将为你梳理新婚第一周的心理适应指南。',
    category: 'juese-shiying',
    categoryName: '角色适应',
    coverImage: 'https://readdy.ai/api/search-image?query=Warm%20cozy%20living%20room%20with%20soft%20morning%20light%20streaming%20through%20curtains%2C%20a%20young%20woman%20sitting%20on%20sofa%20with%20tea%20cup%2C%20peaceful%20atmosphere%2C%20soft%20cream%20and%20beige%20tones%2C%20elegant%20lifestyle%20photography%2C%20warm%20natural%20lighting%2C%20cozy%20home%20interior%2C%20minimalist%20decor%2C%20gentle%20feminine%20aesthetic&width=800&height=500&seq=article-cover-001&orientation=landscape',
    author: '晓薇',
    readTime: '8分钟',
    publishedAt: '2026-07-28',
    featured: true,
    content: `新婚的第一周，往往是情绪最为复杂的一段时间。婚礼的喜悦还未散去，两个人共同生活的现实就扑面而来。

<h2>一、允许自己有一个过渡期</h2>
<p>从恋爱到结婚，虽然两个人已经相处了很长时间，但真正住在一起后，你会发现很多细微的差别。他在生活中有一些你之前不知道的习惯，而你也会在朝夕相处中展现出更真实的自己。</p>
<p>请不要对自己要求太高。适应一个新的角色需要时间，允许自己有一个过渡期，不必苛求自己立刻成为一个"完美妻子"。</p>

<h2>二、建立属于你们的生活节奏</h2>
<p>新婚第一周，最重要的是建立属于两个人的生活节奏。谁负责做早餐？晚上几点休息？周末如何安排？这些看似琐碎的事情，实际上构成了婚姻生活的日常骨架。</p>
<p>建议你们可以坐下来，一起聊聊对日常生活的期待。这不是在制定规则，而是在共同描绘未来生活的样子。</p>

<h2>三、保持开放的心态</h2>
<p>婚姻中的很多摩擦，都源于"我以为你知道"的假设。他没有读心术，你也没有。保持开放的心态，主动表达自己的想法和需求，同时也要耐心倾听对方。</p>

<h2>四、给自己留一些独处空间</h2>
<p>成为妻子不意味着要放弃自我。在婚姻中保持一定的独立性，对自己和婚姻都有好处。每天留出一段属于自己的时间，读书、运动、或者只是安静地喝杯茶。</p>

<h2>五、享受新婚的甜蜜</h2>
<p>别忘了，新婚是最美好的时光之一。放下焦虑，享受两个人在一起的每一刻。那些在厨房一起做饭的傍晚，窝在沙发上看电影的深夜，都会成为日后最珍贵的回忆。</p>`,
  },
  {
    slug: 'fuqi-jiaoliu-wu-ge-jiqiao',
    title: '夫妻交流的五个黄金技巧：让爱在沟通中升温',
    excerpt: '很多婚姻问题的根源，都出在沟通上。明明彼此相爱，说出的话却总是变成伤害的武器。掌握这五个夫妻沟通的黄金技巧，让你的婚姻在每一次交谈中更加亲密。',
    category: 'fuqi-goutong',
    categoryName: '夫妻沟通',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20young%20couple%20sitting%20on%20a%20balcony%20at%20sunset%2C%20facing%20each%20other%20and%20talking%20warmly%2C%20soft%20golden%20hour%20light%2C%20intimate%20atmosphere%2C%20warm%20peach%20and%20cream%20tones%2C%20romantic%20couple%20photography%2C%20gentle%20and%20dreamy%20aesthetic&width=800&height=500&seq=article-cover-002&orientation=landscape',
    author: '若兰',
    readTime: '10分钟',
    publishedAt: '2026-07-25',
    featured: true,
    content: `沟通是婚姻的基石，但真正会沟通的夫妻并不多。很多人把"有话直说"等同于有效沟通，殊不知，同样的话用不同的方式说出来，效果天差地别。

<h2>技巧一：用"我"开头代替"你"开头</h2>
<p>试比较这两句话："你总是回家这么晚！"和"你回来晚的时候，我会感到孤单和担心。"前者是指责，后者是表达感受。没有人喜欢被指责，当你用"我"开头来表达感受时，对方更容易接受并愿意改变。</p>

<h2>技巧二：先倾听，再回应</h2>
<p>很多夫妻之间的"沟通"其实是两个人在轮流发言，而不是真正的对话。当对方在说话时，不要忙着想自己接下来要说什么。真正地倾听——听他的情绪，听他的需求，听他话语背后的意思。</p>

<h2>技巧三：选择合适的时间</h2>
<p>不要在对方刚下班疲惫不堪的时候讨论重要问题，也不要在情绪激动的时候做决定。找一个两个人都比较放松的时间，心平气和地交谈。</p>

<h2>技巧四：学会"暂停"</h2>
<p>当沟通变成争吵时，学会按下"暂停键"。可以约定一个暗号，当任何一方感到情绪快要失控时，暂停10分钟，平复情绪后再继续。</p>

<h2>技巧五：定期进行"情感检查"</h2>
<p>建议每周留出一段固定的时间，和伴侣做一个"情感检查"。聊聊这一周的感受，有什么开心的事，有什么需要对方改进的地方。这个习惯能让小问题不至于积累成大矛盾。</p>`,
  },
  {
    slug: 'po-xi-xiangchu-de-bianjie-yishu',
    title: '婆媳相处的边界艺术：亲而不近，敬而不远',
    excerpt: '婆媳关系被称为"天下第一难题"，但并非无解。本文从边界感入手，教你如何在尊重长辈的同时保护自己的小家庭，实现"亲而不近，敬而不远"的理想婆媳关系。',
    category: 'poxi-xiangchu',
    categoryName: '婆媳相处',
    coverImage: 'https://readdy.ai/api/search-image?query=An%20elegant%20afternoon%20tea%20scene%20with%20two%20women%20of%20different%20generations%20sharing%20tea%20at%20a%20table%20with%20flowers%2C%20warm%20gentle%20light%2C%20harmonious%20atmosphere%2C%20soft%20cream%20and%20rose%20tones%2C%20interior%20with%20fresh%20flowers%2C%20elegant%20lifestyle%20photography&width=800&height=500&seq=article-cover-003&orientation=landscape',
    author: '静怡',
    readTime: '9分钟',
    publishedAt: '2026-07-22',
    featured: true,
    content: `婆媳关系是婚姻中最微妙的一环。处理得好，多了一个疼爱你的长辈；处理不好，可能成为婚姻中的巨大压力源。

<h2>理解婆媳关系的特殊性</h2>
<p>婆媳关系之所以难处，是因为两个原本陌生的女人，因为一个共同爱着的男人而成为"一家人"。这不是自然而然就能亲近的关系，需要双方的经营和智慧。</p>

<h2>建立健康的边界</h2>
<p>边界不是冷漠，而是尊重。明确告诉婆婆，有些决定是你和丈夫之间的事情，需要两个人商量决定。同时，也要尊重婆婆的生活方式和选择，不强加自己的观念给她。</p>

<h2>丈夫是桥梁，不是传话筒</h2>
<p>在婆媳关系中，丈夫的角色至关重要。好的丈夫应该在母亲和妻子之间充当桥梁，而不是简单的传话筒，更不是袖手旁观的局外人。</p>

<h2>用行动表达尊重</h2>
<p>逢年过节的问候、日常的关心、在重要事情上征求她的意见——这些都能让婆婆感受到被尊重。尊重是相互的，你给予尊重，往往也能收获尊重。</p>

<h2>不必强求亲密</h2>
<p>很多新婚妻子会焦虑于"婆婆不喜欢我"或者"我和婆婆不亲近"。其实，婆媳之间保持适当的距离是健康的。不必强求像母女一样亲密，做到相互尊重、相敬如宾就已经很好了。</p>`,
  },
  {
    slug: 'jiehun-hou-ruhe-baochi-ziji',
    title: '结婚后如何保持自我：不做"某某太太"的你',
    excerpt: '婚后最容易丢失的就是"自己"。当生活被家务、丈夫、孩子填满时，你还记得当初那个热爱生活、充满梦想的自己吗？学会在婚姻中保持自我，是每个新婚妻子的必修课。',
    category: 'ziwo-chengzhang',
    categoryName: '自我成长',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20young%20woman%20reading%20a%20book%20by%20a%20large%20window%20with%20sunlight%2C%20surrounded%20by%20plants%2C%20peaceful%20and%20inspiring%20atmosphere%2C%20soft%20warm%20lighting%2C%20cream%20and%20sage%20green%20tones%2C%20elegant%20feminine%20interior%2C%20creative%20lifestyle%20photography&width=800&height=500&seq=article-cover-004&orientation=landscape',
    author: '晓薇',
    readTime: '7分钟',
    publishedAt: '2026-07-20',
    featured: false,
    content: `<p>"你是谁？"——当被问到这个问题时，很多已婚女性会下意识地回答"我是某某的太太"或"我是某某的妈妈"。这个回答本身并没有错，但如果这是你对自己的全部定义，那就需要警惕了。</p>

<h2>婚姻不是你全部的标签</h2>
<p>成为妻子是人生中一个美好的新角色，但它不应该覆盖你原本的样子。你还是那个喜欢音乐的自己，还是那个对工作有追求的自己，还是那个有一群好姐妹的自己。</p>

<h2>保持独立的经济能力</h2>
<p>无论家庭经济状况如何，保持一定的经济独立性都是必要的。这不仅是为了应对意外情况，更是为了在精神上保持独立和自信。</p>

<h2>拥有属于自己的社交圈</h2>
<p>不要因为结婚就放弃自己的朋友和社交。有自己的朋友、自己的兴趣爱好、自己的小圈子，这会让你的生活更加丰富多彩，也能在需要时给你情感支持。</p>

<h2>持续学习和成长</h2>
<p>婚姻不是人生的终点，而是新的起点。保持学习的习惯，无论是专业技能的提升，还是兴趣爱好的培养，都能让你在婚姻中保持活力和魅力。</p>`,
  },
  {
    slug: 'jiawu-fengong-bu-jiandan',
    title: '家务分工不简单：新婚夫妇的实用分工指南',
    excerpt: '"谁洗碗"、"谁拖地"——这些看似鸡毛蒜皮的小事，却常常成为新婚夫妻争吵的导火索。做好家务分工，不仅能让家庭运转更顺畅，还能让两个人的感情更加和谐。',
    category: 'jiating-jingying',
    categoryName: '家庭经营',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20couple%20cooking%20together%20in%20a%20bright%20modern%20kitchen%2C%20smiling%20and%20cooperating%2C%20warm%20natural%20light%2C%20clean%20minimalist%20interior%2C%20cream%20and%20wood%20tones%2C%20happy%20domestic%20life%20photography%2C%20cozy%20home%20atmosphere&width=800&height=500&seq=article-cover-005&orientation=landscape',
    author: '若兰',
    readTime: '6分钟',
    publishedAt: '2026-07-18',
    featured: false,
    content: `<p>家务，是婚姻中最接地气的话题。恋爱时不需要面对的家务问题，结婚后却可能成为每天都要处理的"功课"。</p>

<h2>抛弃"应该"思维</h2>
<p>很多女性在婚后会不自觉地承担更多家务，因为"从小看到妈妈就是这样的"。但时代不同了，家务不是妻子的"天职"，而是两个共同生活的人需要一起承担的责任。</p>

<h2>根据各自优势分工</h2>
<p>每个人擅长的事情不同。也许你擅长整理收纳，他擅长清洁打扫；你喜欢做饭，他不介意洗碗。发挥各自的长处，让家务变成一种互补而不是负担。</p>

<h2>制定灵活的计划</h2>
<p>不要太死板。这周他比较忙，你就多承担一些；下周你比较忙，他多做一些。家务分工的核心是互相体谅，而不是斤斤计较。</p>

<h2>善用科技和工具</h2>
<p>扫地机器人、洗碗机、智能家电——善用这些工具可以大大减少家务负担。投资在家务工具上的钱，往往是最值得的婚姻投资。</p>`,
  },
  {
    slug: 'xinhun-qian-san-ge-yue-mogao-qi',
    title: '新婚前三个月：婚姻磨合期的生存法则',
    excerpt: '婚后的前三个月被称为"婚姻蜜月期"，但同时也是一段重要的磨合期。如何在这段时间里既享受甜蜜又不踩坑？来看看过来人的经验总结。',
    category: 'juese-shiying',
    categoryName: '角色适应',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20newlywed%20couple%20walking%20hand%20in%20hand%20in%20a%20beautiful%20garden%20on%20a%20sunny%20day%2C%20soft%20golden%20light%2C%20romantic%20atmosphere%2C%20cream%20and%20blush%20tones%2C%20wedding%20theme%20photography%2C%20elegant%20and%20dreamy%20aesthetic&width=800&height=500&seq=article-cover-006&orientation=landscape',
    author: '静怡',
    readTime: '8分钟',
    publishedAt: '2026-07-15',
    featured: true,
    content: `<p>婚礼结束后，真正的婚姻生活才刚刚开始。前三个月是最甜蜜的，同时也是最容易出现摩擦的时期。</p>

<h2>接受"不一样"</h2>
<p>两个来自不同家庭背景的人生活在一起，习惯、观念、生活方式的差异会逐一显现。牙膏从中间挤还是底部挤？袜子扔在哪里？这些小事背后反映的是不同的成长环境和生活习惯。接受这些差异的存在，不要试图"改造"对方。</p>

<h2>不要把问题留到明天</h2>
<p>小矛盾如果不及时解决，会像滚雪球一样越滚越大。有了不愉快，当天就说出来、解决掉，不要带着情绪过夜。</p>

<h2>建立共同的婚姻目标</h2>
<p>一起规划未来——什么时候买房？要不要孩子？什么时候去旅行？当两个人有了共同的目标，很多小摩擦就会变得不那么重要。</p>

<h2>保持恋爱的仪式感</h2>
<p>结婚不是恋爱的终点。继续保持约会、互送小礼物、说"我爱你"的习惯。婚姻需要经营，而这些小小的仪式感就是最好的润滑剂。</p>`,
  },
  {
    slug: 'jiazheng-caiwu-touming-gongkai',
    title: '家庭财务透明公开：新婚夫妻的理财第一课',
    excerpt: '钱，是婚姻中最容易引发争吵的话题之一。与其回避，不如坦诚面对。本文为新婚夫妻提供实用的家庭财务管理方案，让你们的婚姻在金钱问题上也充满信任。',
    category: 'jiating-jingying',
    categoryName: '家庭经营',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20couple%20sitting%20at%20a%20wooden%20table%20reviewing%20documents%20and%20budgeting%20together%2C%20warm%20ambient%20lighting%2C%20cozy%20home%20office%20setting%2C%20cream%20and%20wood%20tones%2C%20collaborative%20atmosphere%2C%20modern%20lifestyle%20photography&width=800&height=500&seq=article-cover-007&orientation=landscape',
    author: '若兰',
    readTime: '9分钟',
    publishedAt: '2026-07-12',
    featured: false,
    content: `<p>财务问题在离婚原因排行榜上常年占据前三。但说实话，很多夫妻之间的金钱矛盾，不是因为"钱不够"，而是因为沟通不够。</p>

<h2>婚前就应该坦诚相待</h2>
<p>如果你们还没有深入聊过各自的财务状况——收入、存款、负债、消费习惯——现在就是最好的时机。坦诚是所有信任的基础。</p>

<h2>选择合适的账户模式</h2>
<p>没有一种"最好的"财务模式适合所有夫妻。有人喜欢完全合并账户，有人倾向于各管各的，还有人选折中的"共同账户加个人账户"。关键是要找到让两个人都舒服的方式。</p>

<h2>制定共同的预算</h2>
<p>每月坐下来一起梳理收支，制定下个月的预算。这不仅是财务管理，更是一次关于家庭优先事项的沟通。你们共同的梦想是什么？度假？换房子？还是投资？</p>

<h2>为意外做好准备</h2>
<p>建立一个应急基金，金额覆盖3-6个月的家庭开支。这笔钱不是为了花，而是为了在意外来临时给你安全感。</p>`,
  },
  {
    slug: 'jiehun-hou-he-jiemu-xiangchu',
    title: '结婚后和闺蜜相处：友谊也需要重新定位',
    excerpt: '结婚后，很多女性发现自己和闺蜜的关系发生了微妙的变化。如何在婚姻中保持珍贵的友谊？如何在妻子和朋友两个角色之间找到平衡？',
    category: 'ziwo-chengzhang',
    categoryName: '自我成长',
    coverImage: 'https://readdy.ai/api/search-image?query=Two%20young%20women%20having%20coffee%20and%20laughing%20together%20at%20a%20cafe%2C%20warm%20afternoon%20sunlight%2C%20joyful%20atmosphere%2C%20cream%20and%20rose%20tones%2C%20friendship%20photography%2C%20elegant%20cafe%20interior%2C%20happy%20feminine%20aesthetic&width=800&height=500&seq=article-cover-008&orientation=landscape',
    author: '晓薇',
    readTime: '6分钟',
    publishedAt: '2026-07-10',
    featured: false,
    content: `<p>婚后的社交生活会发生很大变化，其中最让女性感慨的，往往是与闺蜜关系的变化。</p>

<h2>理解关系的变化是正常的</h2>
<p>结婚后，你的时间和精力都会更多地向家庭倾斜。闺蜜可能会觉得被冷落，而你也可能因为减少的联系而内疚。这是正常的过渡，不必过度焦虑。</p>

<h2>质量胜过数量</h2>
<p>可能无法像以前那样频繁见面，但每次相聚的质量更加重要。定期的姐妹聚会、深度的聊天、真诚的分享——这些高质量的相处比频繁但敷衍的见面更有意义。</p>

<h2>让闺蜜融入你的新生活</h2>
<p>可以邀请闺蜜来家里做客，让她认识你的丈夫，了解你的婚后生活。这样她就不会觉得你"结了婚就变了"，而是真真切切地参与到你的幸福中。</p>

<h2>已婚和未婚闺蜜的相处之道</h2>
<p>如果你的闺蜜还没结婚，要注意在聊天中保持话题的多样性。不要让婚姻成为你们唯一的话题，也关心她的生活、工作和情感。</p>`,
  },
  {
    slug: 'laogong-bu-zuo-jiawu-zenmeban',
    title: '老公不做家务怎么办？高效沟通代替抱怨',
    excerpt: '"我跟他说了多少遍了，他还是不做家务！"——这是很多新婚妻子的共同烦恼。与其不断抱怨，不如换一种方式。本文教你如何用沟通代替抱怨，让他主动参与到家务中来。',
    category: 'fuqi-goutong',
    categoryName: '夫妻沟通',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20man%20vacuuming%20the%20living%20room%20floor%20while%20a%20woman%20sits%20on%20sofa%20reading%2C%20modern%20bright%20home%20interior%2C%20warm%20natural%20light%2C%20happy%20domestic%20scene%2C%20cream%20and%20beige%20tones%2C%20lifestyle%20photography%2C%20cozy%20atmosphere&width=800&height=500&seq=article-cover-009&orientation=landscape',
    author: '静怡',
    readTime: '7分钟',
    publishedAt: '2026-07-08',
    featured: false,
    content: `<p>这可能是新婚妻子最常发出的灵魂拷问。但别急着生气，让我们先来理解一下为什么会出现这种情况。</p>

<h2>他不是故意的——理解"标准差异"</h2>
<p>很多时候，他并不是不愿意做家务，而是他觉得"已经够干净了"。每个人对整洁的标准不同，你眼中乱糟糟的客厅，在他看来可能"还好啊"。不是他懒，而是你们的标准不一样。</p>

<h2>具体地请求，而不是笼统地抱怨</h2>
<p>"你能不能帮我做点家务？"——这话太笼统了。换成"亲爱的，能帮我把垃圾拿出去倒一下吗？"——明确、具体、容易执行。大多数人不是不想帮忙，而是不知道该怎么帮。</p>

<h2>感谢每一次的付出</h2>
<p>当他做了家务，无论大小，记得说谢谢。正面的反馈会让他更愿意重复这个行为。批评和抱怨只会让他对做家务产生抵触心理。</p>

<h2>一起做，而不是分配任务</h2>
<p>与其说"你去洗碗，我去拖地"，不如说"我们一起收拾吧"。把做家务变成两个人的互动时间——一边做事一边聊天，时间过得快，感情也会更亲密。</p>`,
  },
  {
    slug: 'jiehun-yizhounian-ganwu',
    title: '结婚一周年感悟：那些新婚时才懂的事',
    excerpt: '从新婚的兴奋到日常的平淡，从偶尔的争吵到更深的默契——结婚一周年，回头看那些只有"过来人"才懂的事，分享给每一位正在路上的你。',
    category: 'hunyin-zhihui',
    categoryName: '婚姻智慧',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20romantic%20first%20anniversary%20dinner%20scene%20with%20candles%20and%20flowers%20on%20a%20table%20by%20window%20with%20city%20lights%2C%20warm%20intimate%20atmosphere%2C%20cream%20and%20gold%20tones%2C%20elegant%20romantic%20photography%2C%20soft%20candlelight%20ambiance&width=800&height=500&seq=article-cover-010&orientation=landscape',
    author: '若兰',
    readTime: '8分钟',
    publishedAt: '2026-07-05',
    featured: true,
    content: `<p>时间过得真快，转眼就结婚一年了。从最初的生疏到如今的默契，这一年的每一天都在教会我什么是婚姻。</p>

<h2>爱情不等于婚姻，但婚姻需要爱情</h2>
<p>恋爱时以为"只要相爱就够了"，结婚后才发现这只是起点。婚姻比爱情复杂得多，它包含了责任、包容、妥协和成长。但正因为有爱，这些"复杂"才变得有意义。</p>

<h2>沟通是婚姻中最重要也最难的事</h2>
<p>一年下来，我最大的感悟是：大多数矛盾不是因为不爱了，而是因为不会说话。说出来、好好说、说清楚——这九个字，需要用一生去练习。</p>

<h2>婚姻不是一个人的事，也不是两个人的事</h2>
<p>我曾经以为婚姻只是两个人的事，但结婚后发现，两个家庭的融合、不同的价值观和习惯，都需要智慧和耐心去处理。</p>

<h2>最好的婚姻，是互相成就</h2>
<p>好的婚姻不会让你失去自己，反而会让你成为更好的自己。在这一年里，我学会了更多地去包容、去理解、去爱——这些成长，比婚礼那天更让我感动。</p>`,
  },
  {
    slug: 'xinhun-qizi-de-xinli-zhunbei',
    title: '新婚妻子的心理准备：比你想象中更需要勇气',
    excerpt: '从恋人到妻子，角色转变带来的不仅是身份的变化，更是心理上的巨大挑战。做好这些心理准备，让你在婚姻的道路上走得更从容。',
    category: 'juese-shiying',
    categoryName: '角色适应',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20young%20woman%20looking%20at%20herself%20in%20a%20beautiful%20mirror%20with%20soft%20morning%20light%2C%20contemplative%20expression%2C%20elegant%20bedroom%20interior%2C%20cream%20and%20blush%20tones%2C%20feminine%20portrait%20photography%2C%20warm%20atmosphere&width=800&height=500&seq=article-cover-011&orientation=landscape',
    author: '晓薇',
    readTime: '7分钟',
    publishedAt: '2026-07-02',
    featured: false,
    content: `<p>很多人以为，结婚就是"从此过上幸福的生活"。但真正经历过的人都知道，婚姻需要勇气，尤其是对于第一次成为妻子的女性来说。</p>

<h2>接受不完美的勇气</h2>
<p>婚姻不是童话。他会有缺点，你也会有缺点；会有甜蜜的时刻，也会有争吵的瞬间。接受婚姻的不完美，才能在不完美中找到属于自己的幸福。</p>

<h2>放下面子的勇气</h2>
<p>在婚姻中，先道歉的人不是输家。有时候为了关系的和谐，放下面子、主动和解，需要比争吵更大的勇气。</p>

<h2>保持独立的勇气</h2>
<p>在亲密的关系中保持自我，在融合的过程中保持独立——这是每个已婚女性都需要面对的课题。不依附、不迷失、不放弃自己的梦想和追求。</p>

<h2>不断成长的勇气</h2>
<p>婚姻是一面镜子，照出你最真实的样子。面对自己的不足、改变不良的习惯、学习更好地爱与被爱——这些都需要勇气，但也是最值得的成长。</p>`,
  },
  {
    slug: 'hunhou-yu-jiamu-xiangchu-jiqiao',
    title: '婚后与父母相处：从"女儿"到"妻子+女儿"的双重身份',
    excerpt: '婚后与原生家庭的关系需要重新定位。如何在做好妻子的同时，继续做一个好女儿？如何在两边的家庭之间找到平衡？这是每对新人都要面对的课题。',
    category: 'poxi-xiangchu',
    categoryName: '婆媳相处',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20warm%20family%20gathering%20scene%20with%20three%20generations%20sitting%20at%20dinner%20table%2C%20harmonious%20family%20atmosphere%2C%20soft%20warm%20lighting%2C%20cream%20and%20wood%20tones%2C%20cozy%20home%20interior%2C%20happy%20family%20photography&width=800&height=500&seq=article-cover-012&orientation=landscape',
    author: '静怡',
    readTime: '9分钟',
    publishedAt: '2026-06-28',
    featured: true,
    content: `<p>结婚不仅是两个人的结合，也是两个家庭的联结。在这个过程中，如何与双方父母相处，是一门需要用心学习的生活艺术。</p>

<h2>建立属于你们小家庭的边界</h2>
<p>结婚后，你和丈夫是一个独立的家庭单位。父母对你的关心可能表现为"过多干涉"，这时候需要温和但坚定地建立边界。不是不孝，而是为了让你们的小家庭健康发展。</p>

<h2>与双方父母保持平等的距离</h2>
<p>尽量做到对双方父母一视同仁。逢年过节的礼物、探望的频率、重大事项的商量——保持平衡才能让两边都感到被尊重。</p>

<h2>丈夫是你的第一伙伴</h2>
<p>在处理双方家庭关系时，你和丈夫应该是一个团队。遇到问题时先和丈夫商量，统一口径后再面对各自的父母。不要让对方成为"夹心饼干"。</p>

<h2>用爱化解代际差异</h2>
<p>父母和我们成长在不同的时代，观念差异在所难免。与其试图改变他们几十年来形成的观念，不如多一些理解和包容。有时候，一个温暖的拥抱胜过千言万语。</p>`,
  },
];

export const getArticlesByCategory = (categorySlug: string) => {
  return articles.filter(a => a.category === categorySlug);
};

export const getFeaturedArticles = () => {
  return articles.filter(a => a.featured);
};

export const getArticleBySlug = (slug: string) => {
  return articles.find(a => a.slug === slug);
};

export const getCategoryBySlug = (slug: string) => {
  return categories.find(c => c.slug === slug);
};